export const visit = (vm, at) => {
vm(require("foundations-components/lang/en-gb.lyaml"));
at({ "en-gb": { "placeholder": "placeholder" } });
};